// Copyright (c) 2019 Deere & Company

const oktaDevl = {
    issuer: 'https://sso-dev.johndeere.com/oauth2/ausgnh3p6ag71v8gs0h7',
    clientId: '0oatyfmrdve4VyjZs0h7',
    scope: ['profile', 'openid', 'authorities', 'warrantyApiAdgroups'],
    PKCE_AUTH_FLOW: true,
};

const oktaQual = {
    issuer: 'https://sso-qual.johndeere.com/oauth2/ausi42oq1q3k7OuZJ0h7',
    clientId: '0oau1vb7qqc0blHry0h7',
    scope: ['profile', 'openid', 'authorities', 'warrantyApiAdgroups'],
    PKCE_AUTH_FLOW: true,
};

const oktaCert = {
    issuer: 'https://sso-cert.johndeere.com/oauth2/aus97evo9eNxmWlTB1t7',
    clientId: '0oafspi620u7G6hht1t7',
    scope: ['profile', 'openid', 'authorities', 'warrantyApiAdgroups'],
    PKCE_AUTH_FLOW: true,
};

const oktaProd = {
    issuer: 'https://sso.johndeere.com/oauth2/aus9ddz3lqJc5gDhH1t7',
    clientId: '0oafzxxdcaNbWKXtM1t7',
    scope: ['profile', 'openid', 'authorities', 'warrantyApiAdgroups'],
    PKCE_AUTH_FLOW: true,
};

const jdwProd = 'warranty.deere.com';
const jdwQual = 'warranty.qual.deere.com';
const jdwCert = 'warranty.cert.deere.com';

export const getOktaCredentials = () => {

    const currentHost = process.env.REACT_APP_ENV;

    switch (currentHost) {

    case jdwProd: return oktaProd;
    case jdwQual: return oktaQual;
    case jdwCert: return oktaCert;
    default: return oktaDevl;

    }

};
